module.exports = __webpack_public_path__ + "static/media/merriweather-light-webfont.726e8a5e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-light-webfont.ttf
// module id = 285
// module chunks = 0